import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, switchMap } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class ApiFetchExportDataService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }


	// Fetch Child Counts Search here
	public getChildReportsCountDetails(data: any): Observable<any> {       
        return this.post<any>(
            EndPoints.studentEligibilityCountExcel,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    // Fetch COE Search GetCoeExportData here
	public getCoeExportData(data: any): Observable<any> {       
        return this.post<any>(
            EndPoints.coeExportData,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

      // Fetch COE Search GetCoeBulkExportData here
	public getCoeBulkExportData(data: any): Observable<any> {       
        return this.post<any>(
            EndPoints.coeBulkExportData,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }



    // Fetch COE Search GetCoeExportData here
	public getCoePrintBulkExportData(data: any): Observable<any> {       
        return this.post<any>(
            EndPoints.coePrintBulkCoeAnswers,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    // Fetch Service Student Data
    getServiceStudentDataCounts(data: any): Observable<any> {
        return this.post<any>(
            EndPoints.studentServiceLists_GetStudentsByPartyService, 
            false, 
            '', {
            chosenRegions: data.chosenRegions,
            chosenCounties: data.chosenCounties,
            chosenSchoolDistricts: data.chosenSchoolDistricts,
            chosenSchools: data.chosenSchools,
            performancePeriod: data.performancePeriod,
            enrollmentPeriods: data.enrollmentPeriods,
            expiredEligibility: data.expiredEligibility,
            expiredQAD: data.expiredQAD,
            grades: data.grades,
            partyServices: data.partyServices,
			serviceCategories: data.serviceCategories

        }, (Headers = {
            ...this.urlProvider.baseGetOptions()
        }) 
        );
    
    }
    

    // Fetch COE ReviewLog GetCoeExportData here
	public getCoeReviewLogExportDataPost(data: any): Observable<any> {       
        return this.post<any>(
            EndPoints.coeReviewLogExportData,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    // Fetch COE GetEnrollments here <-- MIGHT NOT NEED THIS
	public getCoeEnrollmentsExportDataPost(data: any): Observable<any> {       
        return this.post<any>(
            EndPoints.coeReviewLogExportData,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }
	// const url = this.urlProvider.getUrl(EndPoints.studentEligibilityCountExcel, undefined, undefined, undefined);
    //console.log("getChildReportsCountDetails() in api-fetchexportdata.service now returning:")
    //console.log(EndPoints.studentEligibilityCountExcel)

    // Schools Search
   /* public getAllSchools(data: any): Observable<any> {
        const url = this.urlProvider.getUrl(EndPoints.schools, undefined, undefined, undefined);
        return this.post<any>(
            EndPoints.schools,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
        //api/StudentEligibilityLists/GetStudentEligiblityCountExcel
    }*/

    /* public getSpecificSchools(data: any): Observable<any> {
        return this.post<any>(
            EndPoints.schools,
            false,
            '',
            data,
            (Headers = {
                ...this.urlProvider.baseGetOptions()
            })
        );
    }

    */
}
